function hideElement(element) {
    if (!element) return;
    if (!element.classList.contains('hidden')) {
        element.classList.add('hidden');
    }
}

function showElement(element) {
    if (!element) return;
    if (element.classList.contains('hidden')) {
        element.classList.remove('hidden');
    }
}

function hideUniversalErrorModal() {
    hideElement(document.getElementById('universal-error-modal'));
}

function showUniversalErrorModal() {
    showElement(document.getElementById('universal-error-modal'));
}

function showAndHideUniversalErrorModal() {
    showUniversalErrorModal();
    setTimeout(hideUniversalErrorModal, 2000);
}

function getSafeDeletePostRedirectUrl() {
    const fallbackUrl = '/';
    const pageFallbackUrl =
        document.querySelector('[data-delete-post-redirect-url]')?.dataset?.deletePostRedirectUrl ||
        document.body?.dataset?.deletePostRedirectUrl;
    const { referrer } = document;

    if (pageFallbackUrl) {
        try {
            const fallback = new URL(pageFallbackUrl, window.location.origin);
            if (fallback.origin === window.location.origin) {
                return `${fallback.pathname}${fallback.search}${fallback.hash}`;
            }
        } catch {
            /* empty */
        }
    }

    if (!referrer) {
        return fallbackUrl;
    }

    try {
        const redirectUrl = new URL(referrer, window.location.origin);
        const currentUrl = new URL(window.location.href);

        if (redirectUrl.origin !== window.location.origin) {
            return fallbackUrl;
        }

        if (redirectUrl.pathname === currentUrl.pathname) {
            return fallbackUrl;
        }

        return `${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`;
    } catch {
        return fallbackUrl;
    }
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
        return decodeURIComponent(parts.pop().split(';').shift());
    }

    return null;
}

window.showElement = showElement;
window.hideElement = hideElement;
window.hideUniversalErrorModal = hideUniversalErrorModal;
window.showUniversalErrorModal = showUniversalErrorModal;
window.showAndHideUniversalErrorModal = showAndHideUniversalErrorModal;
window.getSafeDeletePostRedirectUrl = getSafeDeletePostRedirectUrl;
window.getCookie = getCookie;
